import request from "@/utils/request";

/**
 * 登录
 * @param data
 * @returns {AxiosPromise}
 */
export function login(data) {
  return request({
    url: "/User/api/User/Login",
    method: "post",
    data
  });
}
/**
 * 房屋征收基本信息
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetLevyBaseInfoDataApi(data) {
  return request({
    url: "/LevyBaseInfo/api/LevyBaseInfo/GetLevyBaseInfoData",
    method: "post",
    data
  });
}
/**
 * 全要素治理
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetSummary(data) {
  return request({
    url: "/Element/api/Element/GetSummary",
    method: "post",
    data
  });
}
/**
 * 全要素清单接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetList(data) {
  return request({
    url: "/Element/api/Element/GetList",
    method: "post",
    data
  });
}
/**
 * 全要素治理明细
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetGovernanceDetailsApi(data) {
  return request({
    url: "/Element/api/Element/GetGovernanceDetails",
    method: "post",
    data
  });
}
/**
 * 运行体征接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function runningSignsApi(data) {
  return request({
    url: "/Sings/api/Sings/GetSummary",
    method: "post",
    data
  });
}
/**
 * 事务所赛马接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetOfficeHorsingData(data) {
  return request({
    url: "/HorseRacing/api/HorseRacing/GetOfficeHorsingData",
    method: "post",
    data
  });
}
/**
 * 事务所从业体征接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetOfficeSignDataApi(data) {
  return request({
    url: "/HorseRacing/api/HorseRacing/GetOfficeSignData",
    method: "post",
    data
  });
}
/**
 * 每月扣分详情接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetOfficeScoreDataApi(data) {
  return request({
    url: "/HorseRacing/api/HorseRacing/GetOfficeScoreData",
    method: "post",
    data
  });
}
/**
 * 拆房公司赛马接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetDemolitionRankDataApi(data) {
  return request({
    url: "/HorseRacing/api/HorseRacing/GetDemolitionRankData",
    method: "post",
    data
  });
}
/**
 * 评估公司赛马接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetAssessCompanyRankApi(data) {
  return request({
    url: "/HorseRacing/api/HorseRacing/GetAssessCompanyRank",
    method: "post",
    data
  });
}
/**
 * 智慧算法接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetIntellegenApi(data) {
  return request({
    url: "/IntellegentAlgorithm/api/IntellegentAlgorithm/GetIntellegentAlgorithmList",
    method: "post",
    data
  });
}
/**
 * 本周城市治理接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetWeeklyUrbanSummaryListApi(data) {
  return request({
    url: "/UrbanManagement/api/UrbanManagement/GetWeeklyUrbanSummaryList",
    method: "post",
    data
  });
}
/**
 * 本周城市治理明细接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetWeeklyUrbanManagementListApi(data) {
  return request({
    url: "/UrbanManagement/api/UrbanManagement/GetWeeklyUrbanManagementList",
    method: "post",
    data
  });
}
/**
 * 闭环接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetRingEventListApi(data) {
  return request({
    url: "/UrbanManagement/api/UrbanManagement/GetRingEventList",
    method: "post",
    data
  });
}
/**
 * 闭环处置接口
 * @param data
 * @returns {AxiosPromise}
 */
 export function GetRingDealRecordListApi(data) {
  return request({
    url: "/UrbanManagement/api/UrbanManagement/GetRingDealRecordList",
    method: "post",
    data
  });
}
export default {
  login,
  GetSummary,
  GetList,
  runningSignsApi,
  GetOfficeHorsingData,
  GetOfficeSignDataApi,
  GetOfficeScoreDataApi,
  GetLevyBaseInfoDataApi,
  GetAssessCompanyRankApi,
  GetDemolitionRankDataApi,
  GetIntellegenApi,
  GetWeeklyUrbanSummaryListApi,
  GetWeeklyUrbanManagementListApi,
  GetRingEventListApi,
  GetRingDealRecordListApi,
  GetGovernanceDetailsApi
};



// WEBPACK FOOTER //
// ./src/api/login/index.js